import React, { Children } from 'react';
import { Star, ShieldCheck, CreditCard, Smartphone } from 'lucide-react';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';
export function SocialProof() {
  const testimonials = [{
    stars: 5,
    quote: 'Llevaba 3 años luchando con la hinchazón. En el día 3 ya notaba la diferencia. Para el día 7, mi esposo me preguntó si había ido al spa. ¡No, solo seguí el protocolo!',
    name: 'María G., 47 años — Miami, FL',
    result: 'Perdió 2 tallas de inflamación en 7 días'
  }, {
    stars: 5,
    quote: 'Pensé que era otra dieta más. Me equivoqué. No pasé hambre ni un solo día. Lo que cambió fue cómo mi cuerpo procesa la comida. Me siento como a los 35.',
    name: 'Carmen R., 52 años — Houston, TX',
    result: 'Recuperó su energía de los 35'
  }, {
    stars: 5,
    quote: 'La guía de compras de Walmart fue un regalo del cielo. Gasté menos de $40 en toda la semana y me sentí más ligera que en años. Mi ropa favorita vuelve a cerrar.',
    name: 'Patricia L., 44 años — Chicago, IL',
    result: 'Su ropa favorita vuelve a cerrarle'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  };
  return <section className="py-20 bg-brand-cream" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-serif text-3xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-249">
            Lo Que Dicen Las Mujeres Que Ya Lo Vivieron
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600" data-id="element-250">
            Resultados reales de mujeres reales en Estados Unidos
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-251">
          {testimonials.map((t, i) => <motion.div key={i} variants={cardVariants} data-id="element-252">
              <Card className="p-8 border-l-4 border-l-brand-gold relative h-full flex flex-col hover:shadow-xl transition-shadow duration-300" data-id="element-253">
                <div className="flex text-brand-gold mb-4" data-id="element-254">
                  {[...Array(t.stars)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" data-id="element-255" />)}
                </div>
                <blockquote className="text-gray-700 italic mb-6 text-lg flex-grow" data-id="element-256">
                  "{t.quote}"
                </blockquote>
                <div className="mt-auto flex items-center gap-3" data-id="element-257">
                  <div className="h-10 w-10 rounded-full bg-brand-gold flex items-center justify-center text-brand-dark font-bold text-sm flex-shrink-0" data-id="element-258">
                    {getInitials(t.name)}
                  </div>
                  <div data-id="element-259">
                    <p className="font-bold text-brand-dark text-sm" data-id="element-260">
                      {t.name}
                    </p>
                    <div className="inline-block bg-brand-gold/10 text-brand-dark text-xs font-bold px-2 py-0.5 rounded-full mt-1 border border-brand-gold/30" data-id="element-261">
                      {t.result}
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 border-t border-brand-dark/10 pt-8" data-id="element-262">
          <div className="flex items-center" data-id="element-263">
            <ShieldCheck className="h-5 w-5 text-brand-dark mr-2" data-id="element-264" />
            Testimonios verificados
          </div>
          <div className="flex items-center" data-id="element-265">
            <CreditCard className="h-5 w-5 text-brand-dark mr-2" data-id="element-266" />
            Pago 100% Seguro
          </div>
          <div className="flex items-center" data-id="element-267">
            <Smartphone className="h-5 w-5 text-brand-dark mr-2" data-id="element-268" />
            Acceso Inmediato
          </div>
        </motion.div>
      </div>
    </section>;
}